// Admin-only presentation helper: lawyers are addressed as "Adv." unless the
// stored name already carries a professional title. Never writes back.
const TITLE_RE = /^(adv\.?|advocate|er\.?|dr\.?|ca|cs|prof\.?|justice|sr\.?\s*adv\.?)\s+/i;

export function formatLawyerDisplayName(name, fallback = "") {
  const raw = (name ?? "").toString().trim();
  if (!raw) return fallback;
  if (TITLE_RE.test(raw)) return raw;
  return `Adv. ${raw}`;
}
